import { render } from "./ComplySyncATO.vue?vue&type=template&id=b0da51b2&scoped=true&ts=true"
import script from "./ComplySyncATO.vue?vue&type=script&lang=ts"
export * from "./ComplySyncATO.vue?vue&type=script&lang=ts"

import "./ComplySyncATO.vue?vue&type=style&index=0&id=b0da51b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0da51b2"]])

export default __exports__